var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCallReq(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 59.992,
    viewBox: "0 0 60 59.992",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M62.857,30.064a30,30,0,1,0-33.637,32.7A30.8,30.8,0,0,0,32.976,63a29.967,29.967,0,0,0,12.8-2.848A8.878,8.878,0,0,0,50.757,53.4a9.22,9.22,0,0,0-1.646-6.77,5.148,5.148,0,0,0,1.5-8.31L47.681,35.38a5.4,5.4,0,0,0-5.83-1.2l-2.816,1.132a.478.478,0,0,1-.522-.11l-7.956-7.978a.5.5,0,0,1-.108-.54l1.124-2.826a5.414,5.414,0,0,0-1.2-5.834l-2.918-2.936a5.128,5.128,0,0,0-8.3,1.508h0L17.314,20.66A11.57,11.57,0,0,0,19.64,33.534L32.2,46.146A11.484,11.484,0,0,0,40.323,49.5a11.358,11.358,0,0,0,4.72-1.022l.28-.128A5.2,5.2,0,0,1,46.8,52.805a4.842,4.842,0,0,1-2.734,3.724A26,26,0,1,1,57.319,42.2a2,2,0,1,0,3.74,1.418,29.937,29.937,0,0,0,1.8-13.55Z",
    transform: "translate(-3.002 -3.004)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallReq);
export default __webpack_public_path__ + "static/media/call-req.e5a4880ddb6e61d32d765d871eb25dc3.svg";
export { ForwardRef as ReactComponent };